export default __webpack_public_path__ + "static/media/marikina-banner.e15eddd0.jpg";